import api from '../api'
export default {

  getStations (page = 0, word = '', size = 5) {
    return api.request('GET', '/station/list?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
  },
  create (form) {
    const myForm = {
      ...form,
      status: form.status === 'Activo' ? 1 : 0
    }
    return api.request('POST', '/station/create', myForm);
  },
  delete(id) {
    return api.request('DELETE', '/station/delete/' + id);
  },
  update(id, form) {
    const myForm = {
      ...form,
      status: form.status === 'Activo' ? 1 : 0
    }
    return api.request('PUT', '/station/update/' + id, myForm);
  },
  getByID (id) {
    return api.request('GET', '/station/' + id);
  },
  getStationByNumber (id) {
    return api.request('GET', '/station/idStation/' + id);
  }

}
